import ButtonIcon from "components/button-icon";
import { NegotiationIcon } from "components/icons/icn-index.icon";
import ImportExportJson from "components/import-export-json";
import moment from "moment";
import { useState } from "react";
import intl from "react-intl-universal";
import { exportNegotiationVolumes } from "services/volume-orders.service";
import { downloadFile } from "utils/custom-functions";

interface IOrderVolumeNegotiationImportProps {
  refresh: (newFilter?: any) => Promise<void>;
  filter?: Record<string, any>;
}

const OrderVolumeNegotiationImport = ({ refresh, filter = {} }: IOrderVolumeNegotiationImportProps) => {
  const [importModalOpen, setImportModalOpen] = useState(false);

  const handleCloseImportModal = () => {
    setImportModalOpen(false);
    refresh();
  }

  const handleDownloadFile = async () => {
    try {
      const result = await exportNegotiationVolumes(filter);
      const fileData = moment(new Date()).format('YYYYMMDD_HHmmss');
      downloadFile(`${intl.get("volumeOrders.negotiationImport.volumeNegotiationFile")}_${fileData}.csv`, 'csv', result);
    } catch (error) {
      console.error("Error to download the file: ", error);
    }
  }

  return(
    <>
      <ButtonIcon 
        buttonIcon={<NegotiationIcon color="var(--color-contrast-brand)" />}
        buttonType="secondary"
        title={intl.get("volumeOrders.negotiationImport.importVolumeNegotiation")}
        onClick={() => setImportModalOpen(true)}
        data-testid="btn-open-import-volume-negotiation"
      />

      {importModalOpen &&
        <ImportExportJson
          open={importModalOpen}
          title={intl.get("volumeOrders.negotiationImport.importVolumeNegotiation")} 
          contextModal={"volumeNegotiation"} 
          handleClose={handleCloseImportModal} 
          downloadArquivo={handleDownloadFile} 
        />
      }
    </>
  );
};

export default OrderVolumeNegotiationImport;
